var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"loader",class:{ 'loader--animated': _vm.animated, [`loader--${_vm.variant}`]: true },style:({ '--color': _vm.rgbColor })},[(_vm.variant === 'dots-2')?[_c('span'),_c('span'),_c('span')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }